import React, { useState, useEffect } from 'react' 
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import Layout from '../../../../components/Layout';
import { AuthUser } from '../../../../components/AuthUser';
import { DetalleFactura } from './DetalleFactura';

import { RequestPage, getVendedor } from '../../../../api/request';
import { Facturas2 } from '../../../../api/requestFacturas';

import Pagination from 'react-responsive-pagination';
import { DetalleFactura2 } from './DetalleFactura2';
import { baseURL } from "../../../../api/ApiURL"

export const ConsultaFacturasCobranzas = () => {

  const params = useParams()
  const navigate = useNavigate()
  const location = useLocation();

  // State del usuario
  const { user } = AuthUser();

  // States para los datos
  const [Factura, setFactura] = useState([]);
  const [Vendedor, setVendedor] = useState();

  // States de paginas
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [urlPage, setUrlPage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  // State del loading
  const [loading, setLoading] = useState(true);

  // States de busqueda
  const [term, setTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [notFound, setNotFound] = useState(false);
  const [searching, setSearching] = useState(false);
  const [inicio, setInicio] = useState('');
  const [fin, setFin] = useState('');

  //state filtro
  const [searchType, setSearchType] = useState(''); // 'Documento'|'Cliente'|'Vendedor'|'Fecha'
const [searchValue, setSearchValue] = useState('');
const [fechaInicio, setFechaInicio] = useState('');
const [fechaFin, setFechaFin] = useState('');
// guarda los parámetros actuales para conservarlos al paginar
const [currentFilters, setCurrentFilters] = useState({});


  // Helper para reemplazar/añadir page en una URL
  const replacePageInUrl = (url, pageNum) => {
  if (!url) return url;
  // Si ya existe page=xxx la reemplazamos
  if (/[?&]page=\d+/.test(url)) {
    return url.replace(/([?&]page=)\d+/, `$1${pageNum}`);
  }
  // si no existe, lo añadimos
  return url.includes('?') ? `${url}&page=${pageNum}` : `${url}?page=${pageNum}`;
}

const buildSearchParams = (pageNum = 1, filters = {}) => {
  const params = new URLSearchParams();
  params.set('page', String(pageNum));

  if (filters.whatToSearch) params.set('whatToSearch', filters.whatToSearch);
  if (filters.Busqueda) params.set('Busqueda', filters.Busqueda);
  if (filters.fechaInicio) params.set('fechaInicio', filters.fechaInicio);
  if (filters.fechaFin) params.set('fechaFin', filters.fechaFin);

  return params.toString(); 
};


const fetchFacturas = async (pageNum = 1, filters = {}) => {
  setLoading(true);
  try {
    const data = await Facturas2('ALL', null, pageNum, filters);
    if (data) {
      setPage(data.current_page ?? data.meta?.current_page ?? 1);
      setTotalPages(data.last_page ?? data.meta?.last_page ?? 1);
      setUrlPage(data.first_page_url ?? data.links?.first ?? '');
      setCurrentPage(data.current_page ?? data.meta?.current_page ?? 1);
      setFactura(data.data ?? []);
      // guarda filtros actuales
      setCurrentFilters(filters);
    } else {
      setFactura([]);
    }
  } catch (err) {
    console.error(err);
    setFactura([]);
  } finally {
    setLoading(false);
  }
};

// helper: invertir vendedorMap => nombre (lower) -> [codigos]
const findCodigosByNombre = (query) => {
  if (!query) return [];
  const q = query.trim().toLowerCase();
  const result = [];
  Object.entries(vendedorMap).forEach(([codigo, nombre]) => {
    if (!nombre) return;
    const n = String(nombre).toLowerCase();
    // substring match: si quieres match exacto, usa n === q
    if (n.includes(q) || q.includes(n)) result.push(codigo);
  });
  return result;
};

const onSearch = async () => {
  setNotFound(false);

  // prepara objeto con params según tipo
  const filters = {};

  if (searchType === 'Fecha' && fechaInicio && fechaFin) {
    filters.fechaInicio = fechaInicio;
    filters.fechaFin = fechaFin;
  } else if (searchType === 'Vendedor') {
    // 1) si usuario mete un codigo exacto (ej V136) lo usamos directamente
    const codePattern = /^[Vv]?\d+$/;
    if (codePattern.test(searchValue.trim())) {
      filters.whatToSearch = 'Vendedor';
      filters.Busqueda = searchValue.trim();
    } else {
      // 2) buscamos códigos en vendedorMap por nombre (case-insensitive, substring)
      const codes = findCodigosByNombre(searchValue);
      if (codes.length > 0) {
        filters.whatToSearch = 'Vendedor';
        filters.Busqueda = codes.join(','); // p.e. "V136,V12"
      } else {
        // 3) fallback: mandamos el nombre tal cual (por si el backend ya filtra por nombre)
        // y si quieres, también puedes marcar notFound en caso de que quieras feedback inmediato
        filters.whatToSearch = 'Vendedor';
        filters.Busqueda = searchValue.trim();
      }
    }
  } else if (searchType) {
    filters.whatToSearch = searchType;
    filters.Busqueda = searchValue;
  }

  // guarda filtros en estado (fuente local) también
  setCurrentFilters(filters);

  // arma querystring con page=1 + filtros y navega
  const qs = buildSearchParams(1, filters);
  navigate({ pathname: location.pathname, search: `?${qs}` }, { replace: true });

  // carga con filtros (arranca en página 1)
  // NOTA: useEffect también escucha location.search y llamará fetchFacturas,
  // pero llamarlo aquí no rompe nada (si prefieres evita la doble llamada).
  await fetchFacturas(1, filters);
};







  // estado: un diccionario { [codigo]: nombre }
const [vendedorMap, setVendedorMap] = useState({});

const loadFacturas = async () => {
  setLoading(true);
  try {
    const res = await Facturas2('ALL', null, 1); // o el page que toque
    if (res) {
      setPage(res.current_page ?? res.meta?.current_page ?? 1);
      setTotalPages(res.last_page ?? res.meta?.last_page ?? 1);
      setUrlPage(res.first_page_url ?? res.links?.first ?? '');
      setCurrentPage(res.current_page ?? res.meta?.current_page ?? 1);
      const facturas = res.data ?? [];
      setFactura(facturas);

      // Extraer códigos únicos de vendedor
      const codigos = [...new Set(facturas.map(f => f.CodigoVendedor).filter(Boolean))];

      if (codigos.length > 0) {
        // Llamadas concurrentes a getVendedor por cada código único
        const results = await Promise.all(codigos.map(cod => getVendedor(cod).catch(e => null)));

        // Construir un mapa codigo -> nombre (getVendedor devuelve un array)
        const map = {};
        results.forEach((r, idx) => {
          const codigo = codigos[idx];
          // r puede ser null o un array; ajustar según la respuesta de tu API
          map[codigo] = (r && Array.isArray(r) && r[0] && r[0].Nombre) ? r[0].Nombre : null;
        });

        setVendedorMap(map);
      } else {
        setVendedorMap({});
      }
    } else {
      setFactura([]);
      setVendedorMap({});
    }
  } catch (err) {
    console.error('Error loadFacturas:', err);
    setFactura([]);
    setVendedorMap({});
  } finally {
    setLoading(false);
  }
};



  const loadPage = async (pageUrl) => {
  if (!pageUrl) return;
  setLoading(true);
  try {
    const resp = await RequestPage(pageUrl); // puede ser axios response o body
    const body = resp?.data ?? resp; // normalizamos

    // body ahora debería tener current_page, last_page, first_page_url, data
    setPage(body.current_page ?? body.meta?.current_page ?? 1);
    setTotalPages(body.last_page ?? body.meta?.last_page ?? 1);
    setUrlPage(body.first_page_url ?? body.links?.first ?? pageUrl);
    setFactura(body.data ?? []);
    setCurrentPage(body.current_page ?? body.meta?.current_page ?? currentPage);
  } catch (err) {
    console.error('Error loadPage:', err);
  } finally {
    setLoading(false);
  }
}


const handlePageChange = (pageNum) => {
  // actualizamos estado local para que el Pagination muestre el cambio inmediatamente
  setCurrentPage(pageNum);

  // construimos querystring usando los filtros actuales
  const qs = buildSearchParams(pageNum, currentFilters);

  // navegamos — NO llamamos a fetchFacturas aquí
  navigate({ pathname: location.pathname, search: `?${qs}` }, { replace: true });

  // useEffect (que escucha location.search) se encargará de llamar a fetchFacturas
};






useEffect(() => {
  const params = new URLSearchParams(location.search);
  const p = parseInt(params.get('page') || '1', 10);

  // Reconstruir filtros desde la querystring
  const filters = {};
  if (params.get('whatToSearch')) filters.whatToSearch = params.get('whatToSearch');
  if (params.get('Busqueda')) filters.Busqueda = params.get('Busqueda');
  if (params.get('fechaInicio')) filters.fechaInicio = params.get('fechaInicio');
  if (params.get('fechaFin')) filters.fechaFin = params.get('fechaFin');

  // Sincronizar los inputs/estado del UI con lo que venga en la URL
  setSearchType(filters.whatToSearch ?? (filters.fechaInicio ? 'Fecha' : ''));
  setSearchValue(filters.Busqueda ?? '');
  setFechaInicio(filters.fechaInicio ?? '');
  setFechaFin(filters.fechaFin ?? '');
  setCurrentFilters(filters);

  // Cargar facturas con page + filtros
  fetchFacturas(p, filters);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [location.search]);






  // función para limpiar filtros
  const clearFilters = async () => {
    setSearchType('');
    setSearchValue('');
    setFechaInicio('');
    setFechaFin('');
    setCurrentFilters({});
    setNotFound(false);
    navigate({ pathname: location.pathname, search: `?page=1` }, { replace: true });
    await fetchFacturas(1, {});
  };

  return (
    <>
      <Layout>
        {
          (loading) ?
            <>
              <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <span className="loader-documentos"></span>
              </div>
            </> :
            <>
              <div className="consultas-title pt-5">
                <h4 className='bg-belmeny text-light px-5 rounded-pill'>Consulta de Facturas</h4>
              </div>

              <h5 className="text-center mt-2 mb-4 text-belmeny"><i>
                {
                  (user.CodGerente !== null) ?
                    <>
                      Usuario - {user.Nombre} - {user.CodVendedor}
                    </> :
                    <>
                      Vendedor - {user.Nombre} - {user.CodVendedor}
                    </>
                }
              </i></h5>

              {/* ======== FILTROS (poner aquí la UI con dropdown/input/fechas) ======== */}
              <div className="container mb-3">
                <div className="row align-items-center gy-2">
                  <div className="col-auto">
                    <select
                      className="form-select"
                      value={searchType}
                      onChange={(e) => {
                        setSearchType(e.target.value);
                        // reset value fields al cambiar tipo
                        setSearchValue('');
                        setFechaInicio('');
                        setFechaFin('');
                      }}
                      style={{ minWidth: 180 }}
                    >
                      <option value="">-- Filtro --</option>
                      <option value="Documento">Documento</option>
                      <option value="Cliente">Cliente</option>
                      <option value="Vendedor">Vendedor</option>
                      <option value="Fecha">Fecha</option>
                    </select>
                  </div>

                  {/* input texto (Documento, Cliente, Vendedor) */}
                  {searchType && searchType !== 'Fecha' ? (
                    <div className="col-auto">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Buscar por ${searchType}`}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
                      />
                    </div>
                  ) : null}

                  {/* inputs de fecha (si seleccionó Fecha) */}
                  {searchType === 'Fecha' ? (
                    <>
                      <div className="col-auto">
                        <input
                          type="date"
                          className="form-control"
                          value={fechaInicio}
                          onChange={(e) => setFechaInicio(e.target.value)}
                        />
                      </div>
                      <div className="col-auto">
                        <input
                          type="date"
                          className="form-control"
                          value={fechaFin}
                          onChange={(e) => setFechaFin(e.target.value)}
                        />
                      </div>
                    </>
                  ) : null}

                  <div className="col-auto">
                    <button className="btn btn-primary me-2" onClick={onSearch}>Buscar</button>
                    <button className="btn btn-outline-secondary" onClick={clearFilters}>Limpiar</button>
                  </div>

                  {/* opcional: mostrar resumen de filtros activos */}
                  <div className="col">
                    {searchType ? (
                      <small className="text-muted">
                        Filtro activo: <strong>{searchType}</strong>
                        {searchType !== 'Fecha' && searchValue ? ` — ${searchValue}` : ''}
                        {searchType === 'Fecha' && fechaInicio && fechaFin ? ` — ${fechaInicio} a ${fechaFin}` : ''}
                      </small>
                    ) : <small className="text-muted">Sin filtros</small>}
                  </div>
                </div>
              </div>
              {/* ======== FIN FILTROS ======== */}

              <div className="container-fluid d-md-block d-none  mb-3">
                <div className="rounded-0 my-2">
                  {
                    (notFound) ?
                      <div className="alert alert-danger text-center" role="alert">
                        <h5>No se encontraron resultados</h5>
                      </div> :
                      <>
                        <table className='table table-bordered table-hover border-belmeny '>
                          <thead className='bg-belmeny text-light text-center'>
                            <tr>
                              <th>Factura</th>
                              <th>Cliente</th>
                              {(user.CodGerente !== null) ? <th>Vendedor</th> : null}
                              <th>Monto</th>
                              <th>Fecha</th>
                              <th style={{ width: "15%" }}>Opciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              Array.isArray(Factura) && Factura.length > 0 ? (
                                Factura.map((item) => (
                                  <DetalleFactura2
                                    item={item}
                                    vendedor={ item.VendedorNombre ?? vendedorMap[item.CodigoVendedor] ?? null }
                                    key={item.Documento}
                                  />
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={(user.CodGerente !== null) ? 6 : 5} className="text-center py-4">
                                    No hay facturas para mostrar.
                                  </td>
                                </tr>
                              )
                            }
                          </tbody>
                        </table>
                      </>
                  }
                </div>

                <Pagination
                  total={totalPages}
                  current={currentPage}
                  onPageChange={page => handlePageChange(page)}
                />
              </div>

              <div className="container-fluid d-sm-block d-md-none">
                {
                  (notFound) ?
                    <div className="alert alert-danger text-center" role="alert">
                      <h5>No se encontraron resultados</h5>
                    </div> :
                    <>
                      <div className="rounded-0 my-2">
                        {
                          Array.isArray(Factura) && Factura.length > 0 ? (
                            Factura.map((item) => (
                              <DetalleFactura2
                                item={item}
                                vendedor={ item.VendedorNombre ?? vendedorMap[item.CodigoVendedor] ?? null }
                                key={item.Documento + "Mobile"}
                              />
                            ))
                          ) : (
                            <div className="text-center py-4">No hay facturas para mostrar.</div>
                          )
                        }
                      </div>

                      <Pagination
                        total={totalPages}
                        current={currentPage}
                        onPageChange={page => handlePageChange(page)}
                      />
                    </>
                }

                <div className="division bg-belmeny my-3"></div>
              </div>
            </>
        }
      </Layout>
    </>
  )

}
